<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" align="center">
        <h2>Consultant</h2>
        <span class="headline">{{ consultantName }}</span>
      </v-col>
      <v-col cols="12" sm="6" align="center" class="hide-on-print">
        <h2>Total Pay</h2>
        <span class="headline">{{ totalPayAmount | currency }}</span>
      </v-col>
      <v-col cols="12" sm="6" align="center" class="hide-on-print">
        <h2>Pay Frequency</h2>
        <span class="headline">{{ payFrequencyId | getPayFrequencyLabel }}</span>
      </v-col>
      <v-col cols="12" sm="6" align="center" class="hide-on-print">
        <h2>Pay Rate</h2>
        <span class="headline">{{ payRate | currency }} {{ payRateTypeId | getPayRateTypeLabel }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    'consultantName',
    'totalPayAmount',
    'payFrequencyId',
    'payRateTypeId',
    'payRate'
  ]
}
</script>
